import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface State {
  file: FileId;
  playing: boolean;
}

const initialState: State = {
  file: 0,
  playing: false,
};

// T H U N K S

// S L I C E

export const appSlice = createSlice({
  name: 'pp',
  initialState,
  reducers: {
    setFile: (state, action: PayloadAction<FileId>) => {
      state.file = action.payload;
    },
    setPlaying: (state, action: PayloadAction<boolean | undefined>) => {
      state.playing = action.payload ?? !state.playing;
    },
  },
});

export const { setFile, setPlaying } = appSlice.actions;
export default appSlice.reducer;
